import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const TechnicalInfoFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M16.58 19.88H7.44L2.86 11.96L7.44 4.04H16.58L21.14 11.96L16.58 19.88ZM12 9.3C10.58 9.3 9.32 10.5 9.32 11.96C9.32 13.42 10.58 14.62 12 14.62C13.42 14.62 14.68 13.42 14.68 11.96C14.68 10.5 13.42 9.3 12 9.3Z" />
    </SvgIcon>
  );
});
